import React, { useEffect, useState } from "react";

export default function Counter({ to = 0, duration = 1800, suffix = "" }) {
  const [val, setVal] = useState(0);

  useEffect(() => {
    let start;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(eased * to));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [to, duration]);

  return (
    <span>
      {val}
      {suffix}
    </span>
  );
}
